module.exports = __webpack_public_path__ + "media/src/images/page03_sub_010-11dc1f53791b1c428277157c762097e6.gif";